export default __webpack_public_path__ + "images/383a31906a68e5567aca79c53a641bb2-sikhism.jpg";